module.exports = __webpack_public_path__ + "img/ico-boosting.a5a479de.svg";